import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { MsalService } from "@azure/msal-angular";
import { Store } from "@ngxs/store";
import { Users } from "county-api";
import { NotificationsService } from "src/app/universal/notifications/notifications.service";
import { UserState } from "src/app/users/store/user.state";
import { environment } from "src/environments/environment";

@Component({
    selector: 'closing-check-admin',
    templateUrl: './closing-check-admin.component.html',
    styleUrls: ['closing-check-admin.component.scss'],
})
export class ClosingCheckAdminComponent implements OnInit {

    locationSelected = "";
    username = "";
    /**
     *
     */
    constructor(private authService: MsalService,
                    private httpservice: HttpClient,
                    private route: ActivatedRoute,
                    private store: Store,
                    private notification: NotificationsService)  {

        
    }
    ngOnInit(): void {
        this.route.data.subscribe((data: { user: Users.IUser }) => {
                    this.username = this.store.selectSnapshot(UserState.user).username;                
        });
    }

    readonly locations: string[] = [
        "Stockport",
        "Oldham",
        "Preston",
        "Chester"
    ];

    

    get canResetBranchSession(){
        return this.locationSelected.length > 0;
    }

    resetBranchSession(){
        const today = new Date();
        this.submitSessionReset(this.locationSelected, this.username, this.formatCheckinDateTime(today))
    }

    formatCheckinDateTime(d: Date) {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${y}-${m}-${day}`;
    }

    submitSessionReset(branch: string, username: string, date: string) {
            const account = this.authService.instance.getAllAccounts()[0];
            const accessTokenRequest = {
                scopes: ["user.read"],
                account: account,
               };
    
            this.authService.acquireTokenSilent(accessTokenRequest).subscribe(x => {
                const accessToken = x.accessToken;

                const request = {
                    username: username,
                    location: branch,
                    date_time: date
                };
                
                this.postSessionResetRequest(accessToken, request).subscribe(
                        response => {
                            this.notification.success("Session reset");
                        },
                errorResponse => {
                    this.notification.error("Error happened when trying to reset session.");
                });
            });  
        };

    postSessionResetRequest(accessToken: string, sessionResetRequest: any){
            
                    const url = environment.apiUrl + `api/v2/closingchecks/ClearPresenceSession`;
                    const postObservable = this.httpservice.post<any>(
                        url,
                        sessionResetRequest,
                        {
                            headers: { 
                                "Authorization": accessToken,
                                'Accept': 'application/json', 
                            },
                            'responseType': 'json'
                        },
                    );
                    return postObservable;
    }
}
    